import { render, staticRenderFns } from "./OvertimeRequestDetailDialog.vue?vue&type=template&id=b188625a&"
import script from "./OvertimeRequestDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./OvertimeRequestDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OvertimeRequestDetailDialog.vue?vue&type=style&index=0&id=b188625a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports